import React, { FC, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Portal } from 'ncoded-component-library';
import { INITIAL_POSITION } from 'data/global';

import './ChartTooltip.styles.scss';

const TOP_PADDING = 20;

type ChartTooltipProps = {
  url: string;
  alt: string;
  isOpen?: boolean;
};

const ChartTooltip: FC<ChartTooltipProps> = ({ url, alt, isOpen }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [mousePosition, setMousePosition] = useState(INITIAL_POSITION);

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) =>
      setMousePosition({
        left: event.clientX,
        top: event.clientY - TOP_PADDING,
      });

    const handleScroll = () => setMousePosition(INITIAL_POSITION);

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('scroll', handleScroll, true);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  return (
    <Portal isOpen={isOpen}>
      <div
        className={classNames('chart-tooltip', {
          'chart-tooltip--loaded': isLoaded,
        })}
        style={mousePosition}
      >
        <img src={url} alt={alt} onLoad={() => setIsLoaded(true)} />
      </div>
    </Portal>
  );
};

export default ChartTooltip;
